import { LucideIcon } from 'lucide-react';

export interface TopicItem {
  id: string;
  title: string;
  description: string;
  category: string;
  level: 'Базовый' | 'Продвинутый' | 'Экспертный';
}

export const TOPICS_DATA: TopicItem[] = [
  { id: 'intro', title: 'Введение в алгоритмизацию', description: 'Базовый синтаксис, переменные и структуры данных', category: 'Основы', level: 'Базовый' },
  { id: 'structure', title: 'Управляющие конструкции', description: 'Условные операторы if/else и логические выражения', category: 'Основы', level: 'Базовый' },
  { id: 'loops', title: 'Циклы и итерации', description: 'Циклы for, while и оптимизация обхода коллекций', category: 'Алгоритмы', level: 'Базовый' },
  { id: 'functions', title: 'Функции и модули', description: 'Декомпозиция, замыкания и организация пакетов', category: 'Архитектура', level: 'Продвинутый' },
  { id: 'data', title: 'Структуры данных и алгоритмы', description: 'Словари, множества, связные списки и поиск', category: 'Алгоритмы', level: 'Продвинутый' },
  { id: 'oop', title: 'Объектно-ориентированное программирование', description: 'Классы, инкапсуляция, наследование и полиморфизм', category: 'Архитектура', level: 'Продвинутый' },
  { id: 'fintech_api', title: 'FinTech API и безопасность', description: 'Работа с транзакциями, токенами, HMAC и 2FA', category: 'FinTech', level: 'Экспертный' },
  { id: 'uzdigcomp_sec', title: 'Кибербезопасность (UzDigComp-AI)', description: 'Протоколы защиты коммерческой тайны и персональных данных', category: 'Безопасность', level: 'Экспертный' },
];

